import { render, staticRenderFns } from "./EpiImageGallery.vue?vue&type=template&id=5a9648ef&scoped=true"
import script from "./EpiImageGallery.vue?vue&type=script&lang=js"
export * from "./EpiImageGallery.vue?vue&type=script&lang=js"
import style0 from "./EpiImageGallery.vue?vue&type=style&index=0&id=5a9648ef&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9648ef",
  null
  
)

export default component.exports